import type { Keyword } from '../keywords/keyword';
import type { Company } from '../companies/company';

export const STATUS = {
  inProgress: 0,
  failed: 1,
  canceled: 2,
  succeeded: 3,
  executed: 4,
  abort: 5,
};

export const ANGEL_TYPE = {
  none: 0,
  typeA: 1,
  typeB: 2,
  typeBOtherwiseA: 3,
  typeAAndPreSeed: 4,
  typeBAndPreSeed: 5,
  typeAOtherwisePreSeed: 6,
  typeBOtherwiseAOrPreSeed: 7,
  typeBOtherwiseAAndPreSeed: 8,
  typeBOtherwisePreSeed: 9,
};

export const EDITOR_SUB_VERSION = {
  editorSubVersionV0: 0,
  editorSubVersionV1: 1,
};

export const STOCK_TYPE = {
  commonStock: 0,
  stockOption: 1,
};

export const SURPLUS = {
  nothing: 0,
  exist: 1,
  expecting: 2,
};

export const PATENT = {
  nothing: 0,
  exist: 1,
  pending: 2,
  transferring: 3,
  exist_president: 4,
  pending_president: 5,
};

export const SHAREHOLDER_BENEFIT = {
  nothing: 0,
  for_stockholder: 1,
  for_optionholder: 2,
};

export const EDITOR = {
  normal: 0,
  block: 1,
};

// TODO 一時的に分岐
// https://fundinno.com/projects/512 用に追加したが後ほど削除
export const TEMP_FUNDINNO_3301_PROJECT = {
  id: 512,
};

type Image = {
  url: string;
  thumb: {
    url: string;
  };
  thumb16By9: {
    url: string;
  };
  thumb4By3: {
    url: string;
  };
};

export type Project = {
  id: number;
  name: string;
  originalCompanyName: string;
  shortDescription: string;
  status: number;
  solicit: number;
  solicitLimit: number;
  solicited: number;
  specificSolicitLimit: number;
  specificSolicited: number;
  angelType: number;
  shareholderBenefit: boolean;
  isSucceededWithLimit: boolean;
  image: Image;
  productsSize: number;
  caseStudiesSize: number;
  investorsSize: number;
  waitingWaitOrder: boolean;
  waitRemainTime: string;
  startAt: string;
  finishAt: string;
  failedAt: string;
  succeededAt: string;
  executionAt: string;
  executionPrice: number | null;
  succeededPrice: number | null;
  delivAt: string | null;
  delivPrice: number | null;
  company: Company;
  stockType: number;
  editorVersion: number;
  editorSubVersion: number;
  descriptionVcInvested: boolean;
  descriptionCompanyInvested: boolean;
  descriptionAngelInvested: boolean;
  descriptionFundinnoFunded: boolean;
  descriptionSurplus: number;
  descriptionServiceLaunched: boolean;
  descriptionPatent: number;
  descriptionAngelType: number;
  descriptionShareholderBenefit: number;
  descriptionStockType: number;
  isWithdraw: boolean;
  withdrawReason: string;
  keywords: Array<Keyword>;
};
